import { createSlice } from '@reduxjs/toolkit';

export const EARTHQUAKES = 'Earthquakes';
export const HURRICANE = 'Hurricane';
export const NWS_ALERTS = 'NWS alerts';
export const POWER_OUTAGE = 'Power Outage';
export const WILD_FIRES = 'Wild Fires';

const initialState = {
  eventToggles: [
    { name: EARTHQUAKES },
    { name: HURRICANE },
    { name: NWS_ALERTS },
    { name: POWER_OUTAGE },
    { name: WILD_FIRES },
  ],
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setEventToggles(state, action) {
      state.eventToggles = action.payload;
    },
  },
});

export const { setEventToggles } = mapSlice.actions;

export const selectEventToggles = (state) => state.map.eventToggles;
export default mapSlice;
